<template>
    <div>
       <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="员工类型">
              <el-select v-model="form.type"  placeholder="请选择类型">
                <el-option label="分销商" :value="1"></el-option>
                <el-option label="招商经理" :value="2"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item label="手机号码">
            <el-input v-model="form.mobile" placeholder="请输入手机号码(必填)"></el-input>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="form.name" placeholder="请输入分销商姓名(必填)"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSave">保存信息</el-button>
            <el-button type="default" @click="reset">继续添加</el-button>
          </el-form-item>
        </el-form>
    </div>  
</template>
<script>
 
  export default {
    data() {
      return {
        form: {
          id:'',
          mobile:'',
          name: '',
          type:''
        },
        processing:false
      }
    },
    created(){
          this.form.id=this.$route.query.userid==undefined?0:this.$route.query.userid
          this.initUser(this.form.id)
    },
    methods: {
      initUser(id){
          this.$post("/User/initUser",{id:id}).then((data)=>{
              if(this.form.id>0 && data.result.info.user!=""){
                 this.form=data.result.info.user
              }
          })
      },
      onSave() {
          if(this.processing){
             this.$message.error("请等待处理完成");return false
          }
          if(this.form.type==''){
            this.$message.error("请选择员工类型");return false
          }
          if(this.form.mobile==''){
            this.$message.error("手机号码不能为空");return false
          }
          if(this.form.name==''){
            this.$message.error("分销商名字不能为空");return false
          }
         
          this.processing=true
          this.$post("/User/saveUser",{userinfo:this.form}).then((data)=>{
               this.processing=false
               if(data.result.success){
                   this.$message({message:"保存基础信息成功",type:'success'})
                   this.form.id=data.result.info
               }else{
                   this.$message.error(data.result.info)
               }
          })
      },
      reset(){
        this.form ={
          id:'',
          mobile:'',
          name: '',
          type:'',
        }
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
